<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item label="角色:" label-width="70px">
					<el-input v-model="filters.roleName"  size="small"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary"  size="small" v-on:click="getGridData">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary"  size="small" @click="addInfo">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="grid_data"  height="calc(100vh - 220px)"  border highlight-current-row v-loading="listLoading" @selection-change="selectGridChange" style="width: 100%;">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column prop="roleName" label="角色" width="150">
			</el-table-column>
			<el-table-column prop="purviewNames" label="菜单权限" width="550">
			</el-table-column>
			<el-table-column label="操作" min-width="250">
				<template scope="scope">
					<el-button size="small" @click="editInfo(scope.$index, scope.row)">编辑</el-button>
					<el-button size="small" @click="delInfo(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<pagination :totalPage="total" :currentPage="filters.page" :pageSize="filters.rows"
			@pageSizeCallBack="handleSizeChange" @currentPageCallBack="handleCurrentChange"></pagination>
		
      <addsave :showTitle="showTitle" :dialogAddShow="dialogAddShow"  :mid="mid" @saveCallBack="saveCallBack"  @getVisible="closeDialog"></addsave>
	</section>
</template>
<script>
import pagination from '@/components/common/pagination.vue'
	import addsave from '../admin/eslroleadd.vue'

	export default {
		name:"eslrolelist",
		components: { addsave,pagination },
		data() {
			return {
				filters: {
					roleName: '',
					rows:10,
					page:1
				},
				grid_data: [],
				total: 0,
				listLoading: false,
				sels: [],//列表选中列
				showTitle:"",
				dialogAddShow:false,
				mid:0
			}
		},
		methods: {
			handleSizeChange(val) {
				this.filters.rows = val;
				this.getGridData();
			},
			handleCurrentChange(val) {
				this.filters.page = val;
				this.getGridData();
			},
			//获取列表
			getGridData() {
				this.listLoading = true;
				let formData=this.$util.jsonToForm(this.filters);
				this.$axios.post("/backadmin/geteslrolelist",formData).then(res=>{
					this.listLoading = false;
					this.total=res.data.total;
					this.grid_data=res.data.data;
				});
			},
			//删除
			delInfo: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					let formData=new FormData();
					formData.append("id",row.roleID);
					this.$axios.post("/backadmin/eslroledel",formData).then(res=>{
						if (res.data.status == 0) {
							this.$message("删除成功!");
							this.getGridData();
						} else {
							this.$message(res.data.msg);
						}
					});
				});	
			},
			addInfo:function(){
				this.showTitle="新增角色";
				this.dialogAddShow=true;
				this.mid=0;
			},
			//显示编辑界面
			editInfo: function (index, row) {
				this.showTitle="编辑角色";
				this.dialogAddShow=true;
				this.mid=row.roleID;
			},
			saveCallBack:function(){
				this.dialogAddShow=false;
				if(this.mid==0){
					this.handleCurrentChange(1);
				}
				else{
					this.getGridData();
				}
			},
			closeDialog:function (bool) {
			  this.dialogAddShow = bool
			},
			selectGridChange: function (sels) {
				this.sels = sels;
			}
		},
		mounted() {
			this.getGridData();
		}
	}

</script>

<style scoped>

</style>
